import React from 'react';

import classNames from './EABD2Button.module.scss';

export interface ButtonProps
  extends Readonly<{
    text: string;
    onPress: () => void;
  }> {}

export const Button = React.memo<ButtonProps>((props) => {
  const { text, onPress } = props;

  return (
    <button onClick={onPress} type={'button'} className={classNames.root}>
      {text}
    </button>
  );
});
